// extracted by mini-css-extract-plugin
export default {"container":"Overview_container__MKmsq","main":"Overview_main__K71ae","navigation":"Overview_navigation__s77c6","sideAd":"Overview_sideAd__uLM8q"};